// extracted by mini-css-extract-plugin
module.exports = {"formItem":"index__formItem___38TYk","submitButton":"index__submitButton___2t_sj","cancelButton":"index__cancelButton___3FNyb"};